<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Novo Requisito
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label><span class="required">*</span> Requisito</label>
            <input
              v-model="requirement.name"
              type="text"
              class="form-control"
            >
          </div>
          <div class="col-md-6">
            <label><span class="required">*</span> Empresa</label>
            <select
              v-model="requirement.company_id"
              class="form-control"
            >
              <option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.company_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><span class="required">*</span> Descrição</label>
            <input
              v-model="requirement.description"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="block text-right mt-2">
          <router-link
            to="/requirements"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      requirement: {
        name: '',
        description: '',
        company_id: '',
      },
      companies: [],
    }
  },
  mounted() {
    const self = this

    const { id } = self.$route.params
    if (id) {
      self.getRequirement(id)
    }

    self.getCompanies()
  },
  methods: {
    save() {
      const self = this

      if (self.requirement.id) return self.edit()

      const api = `${this.$store.state.api}requirements`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message('Sucesso', 'Requisito cadastrado com sucesso', 'success')
          this.$router.push('/requirements')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    edit() {
      const self = this
      const api = `${self.$store.state.api}requirements/${self.requirement.id}`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message('Sucesso', 'Requisito editado com sucesso', 'success')
          this.$router.push('/requirements')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()

      fd.append('name', self.requirement.name)
      fd.append('description', self.requirement.description)
      fd.append('company_id', self.requirement.company_id)

      if (self.requirement.id) {
        fd.append('id', self.requirement.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getRequirement(id) {
      const self = this
      const api = `${self.$store.state.api}requirements/${id}`

      axios
        .get(api)
        .then(response => {
          self.requirement = response.data.data[0]
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getCompanies() {
      const self = this
      const api = `${self.$store.state.api}companies`

      axios
        .get(api)
        .then(response => {
          console.log(response)
          self.usersLoading = true
          self.companies = response.data.data
        })
        .catch(error => {
          // vm.$toast.error(error.response.data.message);
        })
    },
  },
}
</script>

<style scoped>
</style>
